var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col d-flex justify-content-around w-100"},[_c('ul',{staticClass:"list-group list-group-flush w-100"},[_vm._t("data")],2)]),_c('div',{staticClass:"col"},[_vm._t("grafico")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }